import React from 'react';
import { Box, Button, IconButton, Input, Text } from '@chakra-ui/react';
import { X } from 'react-feather';
import { toaster } from '@/components/ui/toaster';

type TableFooterJumpProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (pageNum: number) => void;
  totalPages: number;
  jumpToPage: string;
  setJumpToPage: (value: string) => void;
};

export const TableFooterJump = ({
  isOpen,
  onClose,
  onSubmit,
  totalPages,
  jumpToPage,
  setJumpToPage,
}: TableFooterJumpProps) => {
  const handleSubmit = () => {
    const pageNum = Number(jumpToPage);
    if (!isNaN(pageNum) && pageNum >= 1 && pageNum <= totalPages) {
      onSubmit(pageNum);
      onClose();
    } else {
      toaster.create({
        title: 'Invalid page number',
        description: `Please enter a page between 1 and ${totalPages}`,
        type: 'error',
      });
    }
  };

  if (!isOpen) return null;

  return (
    <Box
      position="absolute"
      bottom="32px"
      right="0"
      zIndex="dropdown"
      bg="backgrounds.white"
      borderRadius="md"
      boxShadow="sm"
      px={3}
      py={2}
      display="flex"
      alignItems="center"
      gap={2}
    >
      <Text fontSize="xs" color="typography.secondary">
        Go to page
      </Text>
      <Input
        type="number"
        size="xs"
        value={jumpToPage}
        onChange={(e) => setJumpToPage(e.target.value)}
        w="64px"
        min={1}
        max={totalPages}
        onKeyDown={(e) => {
          if (e.key === 'Enter') handleSubmit();
        }}
        variant="outline"
        borderColor="border.500"
        fontSize="xs"
        _placeholder={{ color: 'text.500' }}
        autoFocus
      />
      <Button
        size="xs"
        fontSize="xs"
        bg="button.primary.default"
        _hover={{ bg: 'button.hover.richYellow' }}
        onClick={handleSubmit}
        color="typography.black"
      >
        Go
      </Button>
      <IconButton aria-label="Close jump" variant="ghost" size="xs" color="icon.default" onClick={onClose}>
        <X size={14} />
      </IconButton>
    </Box>
  );
};
